module.exports = __webpack_public_path__ + "static/media/David Miller Headshot_1620060958393.44954a4d.jpeg";